import {
  type TransactionGroup,
  Transaction_Type,
} from "schema/gen/es/chiikipoint/model/v2/model_pb";
import { t } from "../../../libs/i18n";

export function getTransactionName(
  tx: TransactionGroup["transactionDetails"][0],
) {
  if (tx.transaction?.type === Transaction_Type.TRANSFER_IN) {
    return t("{name}の受け取り", {
      name: tx.fundSource?.name || t("ポイント"),
    });
  }
  if (tx.transaction?.type === Transaction_Type.TRANSFER_OUT) {
    return t("{name}の譲渡", { name: tx.fundSource?.name || t("ポイント") });
  }
  if (tx.transaction?.type === Transaction_Type.PAYMENT) {
    return t("{store}への支払い", { store: tx.store?.name || t("店舗") });
  }
  if (tx.transaction?.type === Transaction_Type.REFUND) {
    return t("{store}からの返金", { store: tx.store?.name || t("店舗") });
  }
  if (tx.transaction?.type === Transaction_Type.PAYMENT_PSINTERNAL) {
    return tx.transaction?.reason || t("ポイント利用");
  }
  if (tx.transaction?.type === Transaction_Type.CHARGE) {
    return (
      tx.transaction?.reason ||
      t("{name}獲得", { name: tx.fundSource?.name || t("ポイント") })
    );
  }
  if (tx.transaction?.type === Transaction_Type.GRANT) {
    if (tx.fundSource?.type === "Charge" && tx.transaction.reason) {
      return tx.transaction.reason;
    }
    return t("{name}獲得", { name: tx.fundSource?.name || t("ポイント") });
  }
  return tx.store?.name || tx.transaction?.reason || "";
}

export function baseTransaction(
  details: TransactionGroup["transactionDetails"],
) {
  const payment = details.find(
    (d) => d.transaction?.type === Transaction_Type.PAYMENT,
  );
  if (payment) {
    return payment;
  }
  return details[0];
}

export function getTransactionIconUrl(
  storeIconUrl: string | undefined,
  type: Transaction_Type | undefined,
): string {
  if (storeIconUrl) {
    return storeIconUrl;
  }

  if (type === Transaction_Type.PAYMENT_PSINTERNAL) {
    return "/misc/icons/local-activity.png";
  }

  if (type === Transaction_Type.GRANT || type === Transaction_Type.CHARGE) {
    return "/misc/icons/gift.png";
  }

  if (
    type === Transaction_Type.TRANSFER_IN ||
    type === Transaction_Type.TRANSFER_OUT
  ) {
    return "/misc/icons/send.png";
  }

  return "/misc/grant.png"; // デフォルトアイコン
}
